import script from "./SecKillDetail.vue?vue&type=script&setup=true&lang=js"
export * from "./SecKillDetail.vue?vue&type=script&setup=true&lang=js"

import "./SecKillDetail.vue?vue&type=style&index=0&id=22ddea5d&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-22ddea5d"]])

export default __exports__